// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 19:50:00

export default {
  "id": "online-car-destruction-simulator-3d",
  "slug": "online-car-destruction-simulator-3d",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/b821577113cd4219a1c7ce9eab890a35-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/b821577113cd4219a1c7ce9eab890a35/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Online Car Destruction Simulator 3D",
      "description": "Experience a high-speed realistic car collision simulator! Drive down slopes and crash into specialized obstacles with various vehicles, all featuring authentic physics and a detailed damage system with separating parts.",
      "instructions": "TAB - pause menu (or Escape)\nMoving W (forward), S (backward), A (left), D (right).\nSpacebar - handbrake.\nShift - nitro.\nC - change camera.\nU - free camera.\nR - reset car.\nK - restore car.\nB - slow down time.\nN - switch car.",
      "genres": [
        "Simulation"
      ],
      "tags": [
        "3d",
        "car",
        "destroy",
        "drift",
        "physics"
      ]
    },
    "zh-CN": {
      "title": "在线3D汽车毁灭模拟器3",
      "description": "体验高速真实汽车碰撞模拟器！驾驶车辆在斜坡上行驶，撞向各种专用障碍物，所有车辆均具备真实的物理效果和详细的损伤系统，部分可分离。",
      "instructions": "TAB - 暂停菜单（或Esc）\n移动W（前进），S（后退），A（左），D（右）。\n空格键 - 手刹。\nShift - 火焰喷射。\nC - 切换摄像头。\nU - 自由摄像头。\nR - 重置车辆。\nK - 恢复车辆。\nB - 减慢时间。\nN - 切换车辆。",
      "genres": [
        "模拟"
      ],
      "tags": [
        "3D",
        "赛车",
        "破坏",
        "漂移",
        "物理"
      ]
    },
    "zh-TW": {
      "title": "線上3D車輛毀壞模擬器3",
      "description": "體驗高速度真實車輛碰撞模擬器！在斜坡上駕馭車輛並撞上專業設計的各種障礙物，所有車輛皆具有真實物理效果和細節化的損壞系統，可分離各部分。",
      "instructions": "TAB - 暫停選單（或 Escape）\n按 W（前進）、S（後退）、A（左）、D（右）移動。\n空格鍵 - 刹車。\nShift - 純硝。\nC - 切換相機。\nU - 自由相機。\nR - 重置車輛。\nK - 恢復車輛。\nB - 慢速時間。\nN - 切換車輛。",
      "genres": [
        "模擬"
      ],
      "tags": [
        "3D",
        "車輛",
        "毀壞",
        "漂移",
        "物理學"
      ]
    },
    "zh-HK": {
      "title": "線上3D汽車損毀模擬器3",
      "description": "體驗高速真實車輛碰撞模擬器！駕馭斜坡並撞向專業設計的各種障礙物，所有車輛均擁有真實物理效果及詳細的損壞系統，部分可分離。",
      "instructions": "TAB - 暂停選單（或Escape）\n移動W（前進）、S（後退）、A（左）、D（右）。\n空格鍵 - 刹車。\nShift - 爆发力。\nC - 切換相機。\nU - 自由相機。\nR - 重置車輛。\nK - 恢復車輛。\nB - 缓慢時間流。\nN - 切換車輛。",
      "genres": [
        "模擬"
      ],
      "tags": [
        "3D",
        "汽車",
        "破壞",
        "漂移",
        "物理學"
      ]
    },
    "ja": {
      "title": "オンライン・カーサイクロニクル・デストラクション・シミュレーター3D",
      "description": "高速でリアルな車の衝突シミュレータを体験！斜面を駆け上がり、様々な車で専門の障害物に衝突し、本物の物理と詳細な損傷システム、分解する部分を特徴とする。",
      "instructions": "TAB - ポーズメニュー（またはEscape）\nW（前進）、S（後退）、A（左）、D（右）で移動。\nスペースバー - ハンドブレーキ。\nShift - ニトロ。\nC - カメラ変更。\nU - フリー カメラ。\nR - 車のリセット。\nK - 車のリストア。\nB - 時間を遅らせる。\nN - 車の切り替え。",
      "genres": [
        "シミュレーション"
      ],
      "tags": [
        "3D",
        "車",
        "破壊",
        "ドリフト",
        "物理"
      ]
    },
    "ko": {
      "title": "온라인 카 데이스트럭션 시뮬레이터 3D",
      "description": "고속 실제 차량 충돌 시뮬레이터를 경험해보세요! various vehicles를 타고 경사면을 내려가 특수 장애물에 충돌하세요. 모든 차량은 정확한 물리학과 세부적인 파손 시스템을 특징으로 하며, 부품이 분리됩니다.",
      "instructions": "TAB - 일시정지 메뉴(또는 Escape)\nW(앞으로), S(뒤로), A(왼쪽), D(오른쪽) 이동.\nSpacebar - 핸드브레이크.\nShift - 니트로.\nC - 카메라 변경.\nU - 자유 카메라.\nR - 차량 초기화.\nK - 차량 복구.\nB - 시간 지연.\nN - 차량 전환.",
      "genres": [
        "시뮬레이션"
      ],
      "tags": [
        "3D",
        "자동차",
        "파괴",
        "드리프트",
        "물리학"
      ]
    },
    "fr": {
      "title": "Simulateur de Destruction de Voitures en Ligne 3D",
      "description": "Expérimentez un simulateur de collision de voiture à haute vitesse et réaliste ! Roulez sur des pentes et entrez en collision avec des obstacles spécialisés avec divers véhicules, tous équipés de physique authentique et d'un système de dommages détaillé avec des parties détachables.",
      "instructions": "TAB - menu de pause (ou Échap)\nMouvement : W (avant), S (arrière), A (gauche), D (droite).\nBarre d'espace - frein à main.\nMaj - nitro.\nC - changer de caméra.\nU - caméra libre.\nR - réinitialiser la voiture.\nK - restaurer la voiture.\nB - ralentir le temps.\nN - changer de voiture.",
      "genres": [
        "Simulation"
      ],
      "tags": [
        "3D",
        "voiture",
        "détruire",
        "drift",
        "physique"
      ]
    }
  }
};
